'use strict';
import $ from 'jquery';
import Mustache from 'mustache';
import Promise from 'bluebird';
import Validator from './validator';
import { getPickupLocations, getOrder, getDeliveryMethods } from '../api/checkout';
import utils from '../util';
import validate from '../api/validation';
import { showValidationErrors, showErrorMessage, inputFilteringEvents } from '../util/form';
import notifications from '../ui/notifications';
import gtm from '../util/gtm';

/**
 * @param {jQuery} $container
 * @param {Boolean} triggerEvents whether to trigger click event on input fields
 */
export const selectSavedDeliveryMethod = ($container) => {
	const savedMethod = $container.data('selected-method');
	const savedLocation = $container.data('selected-location');
	if (savedMethod) {
		// select previousy selected method
		const $input = $container.find(`input[name="deliverymethod"][value="${savedMethod}"]`);
		$input.click();
		$container.on('renderPickupLocations', '.delivery-pickup-locator', (e, data) => {
			const $locationSelect = $input.closest('dt').next('dd').find('.field-pickuplocation');
			if (savedLocation && $locationSelect.find(`option[value="${savedLocation}"]`).length) {
				$locationSelect.val(savedLocation);
			}
		});
	}
}

export default () => {
	const $container = $('.v4-checkout');
	if (!$container.length) return;

	notifications($container.find('> .container'));

	const $form = $container.find('.shipping-details');
	const $shippingMethod = $container.find('.shipping-method');
	const $shippingAddress = $container.find('.shipping-address');
	const $joinClub = $shippingAddress.find('#join_club');
	const $kplussa = $container.find('#kplussa_number');
	const $phone = $container.find('#phone');

	inputFilteringEvents($form)

	const templates = {
		pickupLocations: $('#mustache-pickup-locations').html(),
		alert: $('#mustache-alert').html(),
		deliveryMethods: $('#mustache-checkout-delivery-methods').html()
	};

	const validator = new Validator($form);

	const showErrors = (errors) => {
		errors.filter(error => error.rule === 'username').forEach(error => error.hide = true);
		return showValidationErrors($form, errors);
	}

	/**
   * @param {JQuery} item
   * @param {String} zipCode
   * @param {String} code
   * @return {Promise}
   */
	const getLocations = ($item, code, zipCode, city, address, countryCode) => {
		$item.addClass('loading');
		return getPickupLocations(code, zipCode, city, address, countryCode)
			.finally(() => $item.removeClass('loading'))
	}

	/**
   * @param {JQuery} item
   * @param {Object} data
   * @return {JQuery}
   */
	const renderPickupLocations = ($container, data) => {
		if (( !data.locations || !data.locations.length ) && !data.noZipCode) data.noResults = true;
		const markup = Mustache.render(templates.pickupLocations, data);
		$container.html(markup);
		$container.find('.shipping-methods-list').trigger('render', [data]);

		if ($container.find('option').length) {
			$('.shipping-methods-container .validation-alert').remove();
		}
	}

	/**
   * @param {JQuery} item
   * @param {String} zipCode
   * @return {Promise}
   */
	const updatePickupLocations = ($item, zipCode, city, address, countryCode = 'FI') => {
		const $pickupLocator = $item.find('.delivery-pickup-locator');
		const code = $pickupLocator.data('code');
		const data = {};

		if (zipCode) {
			data.zipCode = zipCode;
		} else {
			data.noZipCode = true;
		}

		const promise = data.zipCode
			? getLocations($pickupLocator, code, zipCode, city, address, countryCode)
			: Promise.resolve([]);

		return promise
			.tap(locations => data.locations = locations)
			.finally(locations => {
				// Guard against rendering into a collapsed (inactive) dd. If the delivery
				// method was switched while this async call was in-flight, the containing dd
				// will be collapsed. Rendering into it would create a ghost
				// <select name="pickuplocation"> that gets included in form serialisation
				// (jQuery serializeArray includes max-height:0 elements), causing the wrong
				// pickup location to be submitted.
				const $dd = $pickupLocator.closest('dd');
				if ($dd.length && $dd.hasClass('collapsed')) {
					return locations;
				}
				renderPickupLocations($pickupLocator, data)
				$pickupLocator.trigger('renderPickupLocations')
				return locations;
			});
	}

	const updateDeliveryMethods = (deliveryMethods) => {
		const $select = $('.shipping-methods-list input[name="deliverymethod"]:checked')
		const templateData = {
			deliveryMethods,
			renderPrice: () => (text, render) => render(text).replace('.',',') + '&nbsp;&euro;'
		};
		if ($select.length) {
			templateData.selectedDeliveryMethod = $select.val()
			const $pickupLocator = $select.closest('dt').next('dd').find('select[name="pickuplocation"]')
			if ($pickupLocator.length) {
				templateData.pickupLocation = $pickupLocator.val()
			}
		}
		const markup = Mustache.render(templates.deliveryMethods, templateData)
		const $alerts = $container.find('.shipping-methods-container .validation-alert').clone()
		$container.find('.shipping-methods-container').html(markup).prepend($alerts)
		selectSavedDeliveryMethod($container.find('.shipping-methods-list'))
	}

	$container.on('updateDeliveryMethods', '.shipping-methods-container', () => {
		const countryCode = $shippingAddress.find('#country').val();
		getDeliveryMethods({ countryCode }).then(updateDeliveryMethods)
	})

	validator.addConditionalRule('password[]', ['password', 'passwordlength', 'required'], (value) => {
		return $joinClub.is(':checked');
	});

	// validate username if joining club
	validator.addConditionalRule('email', 'username');

	// validate that plussa number belongs to user if joining club
	validator.addConditionalRule('kplussa_number', 'plussaBelongsToUser', () => {
		return $joinClub.is(':checked');
	});

	// validate unique phone number if joining club
	validator.addConditionalRule('phone', 'phoneUnique', () => {
		return $joinClub.is(':checked');
	});

	$joinClub.change(e => {
		const params = {}
		const countryCode = $shippingAddress.find('#country').val();
		if (countryCode) {
			params.countryCode = countryCode;
		}
		if ($joinClub.is(':checked')) {
			params.clubPrice = 1
			$('.checkout-club-password').removeClass('hidden')
		} else {
			$('.checkout-club-password').addClass('hidden')
		}
		validator.validateField($kplussa);
		validator.validateField($phone);
		getDeliveryMethods(params).then(updateDeliveryMethods)
	});

	// validation success callback
	validator.on('success', $input => {
		$input
			.removeClass('validation-error')
			.closest('.field')
			.find('.validation-error-msg')
			.remove();
	});

	// validation error callback
	validator.on('fail', ($input, errors) => {
		const usernameErrors = errors.filter(err => err.rule === 'username');
		if (usernameErrors.length === errors.length) {
			validator.emit('success', $input);
		} else {
			showErrors(errors);
		}
	});

	const pickupLocationChangeCallback = ($input, validationPassed) => {
		const $shippingAddress = $input.closest('.shipping-address');
		const zipCode = $shippingAddress.find('#postnumber, #post_number').val();
		const city = $shippingAddress.find('#city').val();
		const address = $shippingAddress.find('#address').val();
		const $selected = $shippingMethod.find('input[type="radio"]:checked');
		if ($selected.length) {
			const countryCode = $shippingAddress.find('#country').val();
			updatePickupLocations(
				$selected.closest('dt').next('dd'),
				validationPassed ? zipCode : null,
				validationPassed ? city : null,
				validationPassed ? address : null,
				countryCode
			);
		}
	}

	// update pickup locations on zip code input
	validator.addCallback('postnumber', pickupLocationChangeCallback);
	validator.addCallback('post_number', pickupLocationChangeCallback);
	validator.addCallback('city', pickupLocationChangeCallback);
	validator.addCallback('address', pickupLocationChangeCallback);

	validator.addCallback('email', ($input, passed, errors = []) => {
		if (passed && !errors.length) {
			$('.club-promo-box').removeClass('hidden');
		} else {
			$joinClub.prop('checked', false);
			$('.club-promo-box').addClass('hidden');
		}
	});

	// validate fields on input change
	$shippingAddress.find('input').focusout(e => {
		const $input = $(e.target);
		const skip = [];
		validator.validateField($input, skip);
	});

	// validate checkbox fields on input change
	$form.find('input[type="checkbox"]').change(function() {
		validator.validateField($(this));
	});

	$shippingAddress.find('#previous-address').change(e => {
		const orderId = $(e.target).val();
		const $loader = utils.addFormLoader($form);
		getOrder(orderId).then(order => {
			$loader.done();
			$.each(order, (key, val) => {
				if (key === 'post_number') key = 'postnumber';
				const $field = $form.find(`input[name="${key}"]`);
				if ($field.length) {
					$field.val(val);
				}
			});
		});
	});

	// update pickup locations and delivery countries for selected delivery method
	$container.on('change', '.shipping-method input[type="radio"]', e => {
		const $input = $(e.target);
		const $details = $input.closest('dt').next('dd');
		const $list = $input.closest('.shipping-methods-list')
		$list.find('dd').addClass('collapsed');
		$list.find('dd').not($details).find('.field-pickuplocation').html('');
		if (!$details.text().trim().length) {
			return;
		}
		$details.removeClass('collapsed');
		const zipCode = $shippingAddress.find('#postnumber, #post_number').val();
		const city = $shippingAddress.find('#city').val();
		const address = $shippingAddress.find('#address').val();
		const countryCode = $shippingAddress.find('#country').val();
		const deliveryMethodName = $input.closest('label').find('.delivery-name').text();
		gtm.checkout.selectDeliveryMethod(deliveryMethodName);
		if ($input.hasClass('has-pickuplocator')) {
			updatePickupLocations($details, zipCode, city, address, countryCode);
		}
	});

	$container.on('update-pickuplocations', '.shipping-methods-list', (e, $item, zipCode, city, address, countryCode) => {
		updatePickupLocations($item, zipCode, city, address, countryCode);
	})


	$container.on('change', '#country', e => {
		$container.find('.shipping-methods-container').trigger('updateDeliveryMethods');
	});

	// submit shipping form and create order
	$form.find('.continue').click(e => {
		e.preventDefault();

		const data = $form.serializeObject();
		const $btn = $(e.target);
		const $loader = utils.addFormLoader($btn, {align: 'after', className: 'float-right'});
		const $selectedMethod = $shippingMethod.find('input[name="deliverymethod"]:checked');

		if (Array.isArray(data.email)) {
			data.email = data.email[0];
		}

		if (Array.isArray(data.pickuplocation)) {
			const activePickupLocation = $selectedMethod.closest('dt').next('dd').find('select[name="pickuplocation"]').val();
			data.pickuplocation = activePickupLocation || '';
		}

		if ($selectedMethod.length && !$selectedMethod.hasClass('has-pickuplocator')) {
			data.pickuplocation = '';
		}

		if (data.kplussa_number) {
			const plussaPrefix = '703240';
			if (data.kplussa_number.indexOf(plussaPrefix) !== 0) {
				data.kplussa_number = plussaPrefix + data.kplussa_number;
			}
		}

		$.each(data, (key, val) => {
			if (key.indexOf('[]') > -1) {
				data[key.replace('[]', '')] = val;
				delete data[key];
			}
		});

		if (typeof data.accepted_privacy_policy === 'undefined') {
			data.accepted_privacy_policy = '';
		}

		// validate shipping address
		return validate({ definition: 'shipping', fields: data })
			.then(res => {
				$form.find('.validation-alert').slideUp('fast', function() {
					$(this).remove();
				});

				if (res.errors && res.errors.length) {
					showErrors(res.errors);
					$loader.done();
					$('html,body').animate({ scrollTop: $shippingAddress.offset().top - 40 });
				} else if (res.pass) {
					//$loader.success();
					const $input = $form.find('input[name=kplussa_number]');
					const plussaValue = $input ? String($input.val() || '') : '';
					const plussaPrefix = '703240';
					if (plussaValue && !plussaValue.startsWith(plussaPrefix)) {
						$input.val(plussaPrefix + plussaValue);
					}

					$form.submit();
				} else {
					$loader.done();
				}
			})
			.catch(res => {
				const message = res.message || 'Hups! Jotain meni pieleen. Yritä hetken kuluttua uudestaan.';
				showErrorMessage(message);
				$loader.done();
			})
	});

	selectSavedDeliveryMethod($container.find('.shipping-methods-list'));
}
